import React from "react";
import { Localizer } from "@/main/react/Types";

type DiscussionPageLoadFailedProps = {
    localizer: Localizer;
    onRetry: () => void;
};

export default function DiscussionPageLoadFailed(props: DiscussionPageLoadFailedProps) {
    const { localizer, onRetry } = props;

    return (
        <div className="mx-auto flex w-full max-w-200 flex-col gap-3 px-4 py-8">
            <div className="rounded-[1.75rem] border border-border/70 bg-card p-5 shadow-[var(--surface-shadow-soft)]">
                <p className="mb-3 text-sm text-muted-foreground">{localizer("paginated.load_failed")}</p>
                <button
                    type="button"
                    className="inline-flex items-center rounded-full border border-border bg-background px-4 py-2 text-sm font-medium text-foreground hover:bg-muted"
                    onClick={onRetry}
                >
                    {localizer("literal.retry")}
                </button>
            </div>
        </div>
    );
}
